function getLastViewItemData() {
    const viewItemEvents = window.dataLayer.filter(item => 
        item.event === 'dl_ga4_view_item' && item.ecommerce && item.ecommerce.detail
    );
    
    if (viewItemEvents.length > 0) {
        const lastViewItem = viewItemEvents[viewItemEvents.length - 1];
        const product = lastViewItem.ecommerce.detail.products[0];
        
        return {
            variant_id: product.variant_id,
            product_id: product.product_id,
            name: product.name,
            brand: product.brand,
            category: product.category,
            price: product.price,
            sku: product.sku
        };
    }
    
    return null;
}

document.addEventListener('click', function(event) {
    if (event.target.closest('#product-information-cart-button')) {
        const button = event.target.closest('#product-information-cart-button');
        
        if (!button.disabled && !button.classList.contains('disabled')) {
            const productData = getLastViewItemData();
            if (productData) {
                // Push event dl_ga4_add_to_cart vào dataLayer
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'dl_ga4_add_to_cart',
                    ecommerce: {
                        add: {
                            products: [{
                                variant_id: productData.variant_id,
                                product_id: productData.product_id,
                                name: productData.name,
                                brand: productData.brand,
                                category: productData.category,
                                price: productData.price,
                                quantity: 1,
                                sku: productData.sku
                            }]
                        }
                    }
                });
            }
        }
    }
});